import React from 'react'

const styles = {
  list: {
    fontSize: '1.4rem',
    fontWeight: '400',
    fontFamily: 'Open Sans',
    // listStyleImage: 'url("/images/list-circle.svg")',
    listStyle: 'none',
    paddingLeft: '0.2rem',
  },
  item: {
    marginBottom: '1.5rem',
    paddingLeft: '3rem',
    background: 'url("/images/list-circle.svg") no-repeat left 0 top 0.5rem',
    backgroundSize: '1rem 1rem',
  },
}

const List = (props) => {
  const { items } = props
  return (
    <ul style={styles.list}>
      {items.map((item, key) => (
        <div key={key}>
          <li style={styles.item}>{item}</li>
        </div>
      ))}
    </ul>
  )
}

List.propTypes = {
  items: React.PropTypes.array,
}

export default List



// WEBPACK FOOTER //
// ./src/browser/components/List.js